import { render, staticRenderFns } from "./ModalCategorie.vue?vue&type=template&id=3caaaa2d&scoped=true"
import script from "./ModalCategorie.vue?vue&type=script&lang=js"
export * from "./ModalCategorie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3caaaa2d",
  null
  
)

export default component.exports